import { render } from "./Pair.vue?vue&type=template&id=2485ffc3&scoped=true"
import script from "./Pair.vue?vue&type=script&lang=ts"
export * from "./Pair.vue?vue&type=script&lang=ts"

import "./Pair.vue?vue&type=style&index=0&id=2485ffc3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2485ffc3"

export default script